<template>
    <router-link  @click="$emit('save')"  class="text-decoration-none btn-container" to="">
        <span>Save</span>
    </router-link>
</template>

<script>

</script>

<style scoped>
    .save-btn{
       cursor: pointer;
    }
</style>